// ======================================================================
// FILE: src/modules/wms/dashboard/components/MyWorkQueueCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   My Work Queue Card (Mock)
// ======================================================================

import React from "react";

export default function MyWorkQueueCard({
  data = [],
}) {

  const queue = Array.isArray(data)
  ? data
  : [];

  return (

    <div className="card shadow-sm h-100">

      <div className="card-header bg-white">

        <h5 className="mb-0">
          My Work Queue
        </h5>

      </div>

      <div className="card-body p-0">

        <div className="list-group list-group-flush">

          {queue.map((item, index) => (

            <button
              key={index}
              type="button"
              className="
                list-group-item
                list-group-item-action
                d-flex
                justify-content-between
                align-items-center
              "
            >

              <div>

                <i
                  className={`${item.icon || "fas fa-circle"} me-2 ${
                    item.color ? `text-${item.color}` : "text-primary"
                  }`}
                />

                {item.title}

              </div>

              <span
                className={`badge ${
                  item.color
                    ? `bg-${item.color}`
                    : "bg-primary"
                }`}
                style={{
                  minWidth: "32px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                {item.count ?? 0}
              </span>

            </button>

          ))}

        </div>

      </div>

    </div>

  );

}